module.exports = __webpack_public_path__ + "img/c62b5e63544b4e3e9761dcca15fea358.996dafe3.png";